import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Observable } from "rxjs/Observable";

import "rxjs/add/operator/map";

import "rxjs/add/operator/do";

import "rxjs/add/operator/catch";

import "rxjs/add/observable/of";

import "rxjs/add/observable/throw";
import { App } from "ionic-angular";
import { LoginPage } from "../../pages/login/login";
import { CONFIG } from "../../config/config";

/*
  Generated class for the RequestServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class RequestServiceProvider {
  // private baseUrl =`http://172.31.3.10:8080/rc/rest/`;

  private laravelBaseUrl = CONFIG.laravelServer;

  private baseUrl = CONFIG.readycashServer;

  private url: string = this.baseUrl + "agent/login";

  private agentUrl: string = this.baseUrl + "agent";

  private accUrl: string = this.baseUrl + "agent/balance";

  private agentProfile: string = this.baseUrl + "agent/profile";

  private billerUrl: string = this.baseUrl + "agent/billproducts";

  private registeragent: string = this.laravelBaseUrl + "agent/registration";

  private saveAgentProfile: string = this.laravelBaseUrl + "agent/profile";

  private saveBusinessProfileUrl: string =
    this.laravelBaseUrl + "agent/profile/business";

  private deleteBusinessProfileUrl: string =
    this.laravelBaseUrl + "agent/profile/business/delete";

  private statesUrl: string = this.baseUrl + "common/states";

  private guessBankUrl: string =
    this.baseUrl + "common/util/guessbank/9202162470";

  private mobileTransferUrl: string =
    this.baseUrl + "agent/transact/transfer/mobile";

  private forgotPasswordUrl: string =
    this.baseUrl + "common/util/forgotpassword";

  private withdrawMoney: string = this.baseUrl + "agent/transact/cashout";

  private nameEnquiry: string =
    "https://www.readycash.com.ng:6443/rc/rest/agent/transact/nameenquiry";

  private bankTransferUrl: string =
    this.baseUrl + "agent/transact/transfer/bank";

  private validateVoucher: string =
    "https://www.readycash.com.ng:6443/rc/rest/agent/validators/voucher";

  private allBillersUrl: string = this.baseUrl + "agent/billers";

  private rechargeUrl: string = this.baseUrl + "agent/transact/airtime";

  private payBillsUrl: string = this.baseUrl + "agent/transact/paybill";

  private billerMarchants: string = this.baseUrl + "agent/merchants";

  private payMerchantUrl: string = this.baseUrl + "agent/transact/paymerchant";

  private changePasswordUrl: string =
    this.baseUrl + "agent/security/changepassword";

  private bankListUrl: string = this.baseUrl + "common/institutions/bank";

  private bankListForSanefUrl: string = this.laravelBaseUrl + "banks";

  private microfinanceBanks: string = this.baseUrl + "common/institutions/mfb";

  private mobileMoneyOperators: string = this.baseUrl + "common/institutions/mmo";

  private validateBillPayment: string =
    this.baseUrl + "agent/validators/bill_subscriber";

  private unusedVochers: string = this.baseUrl + "agent/unused_vouchers";

  private validateMerchant: string =
    this.baseUrl + "agent/validators/merchant_subscriber";

  private accountEnquiryUrl: string = this.laravelBaseUrl + "account/enquiry";

  private createAccountUrl: string = this.laravelBaseUrl + "account/create";

  private fetchMyAccountsUrl: string = this.laravelBaseUrl + "agent/accounts";

  private fetchInsuranceCompanies: string =
    this.laravelBaseUrl + "companies/insurance";

  private eventsUrl: string = this.laravelBaseUrl + "events/";

  private searchAgentAccountsUrl: string =
    this.laravelBaseUrl + "accounts/search";

  private transactionHistoryUrl: string =
    this.baseUrl + "agent/statement?accountType=01";

  private extCashoutValidatoinUrl: string =
    this.baseUrl + "agent/transact/external/cashout/validation";

  private extCashoutUrl: string =
    this.baseUrl + "agent/transact/external/cashout";

  private ussdTransferUrl: string = this.baseUrl + "agent/transact/ussd/cashout";  

  private changePinUrl: string = this.baseUrl + "agent/change_pin";

  private moveIncomeUrl: string = this.baseUrl + "agent/move_income";

  private cashPickUpUrl: string = this.baseUrl + "agent/lists/pickup_locations";

  private cashPickUpTransactionUrl: string =
    this.baseUrl + "agent/transact/cash_pickup";

  private akuCashoutVerificationUrl: string =
    this.baseUrl + "agent/transact/cashout_aku";

  private pendingTransactionList: string =
    this.baseUrl + "agent/transact/pending/list";

  private mposCashout: string = this.baseUrl + "agent/transact/mpos/cashout";

  private linkPinPadUrl: string = this.baseUrl + "agent/terminal/map";

  private checkLinkedPinPadUrl: string = this.baseUrl + "agent/terminal/check";

 // private cardTransactionLogUrl: string = this.baseUrl + `agent/transact/mpos/list?after=0&date=1583712000000`

  constructor(
    private http: Http,
    private app: App,
    private httpClient: HttpClient
  ) {}

  getToken() {
    let token = document.querySelector('meta[property="csrf-token"]')[
      "content"
    ];
    return token;
  }

  guessBankAccount(accountNumber) {
    let headers = new Headers();
    this.createAuthHeader(headers);
    return this.http
      .get(this.baseUrl + "common/util/guessbank/" + accountNumber, { headers })
      .map(res => res.json());
  }

  getUnusedVochers(page, pageSize) {
    let headers = new Headers();

    this.createAuthHeader(headers);

    return this.http
      .get(
        this.baseUrl +
          `agent/unused_vouchers?page=${page}&pageSize=${pageSize}`,
        { headers }
      )

      .map(res => res.json());
  }

  getBankList() {
    return this.http.get(this.bankListUrl).map(res => res.json());
  }

  getSanefBankList(): Observable<any> {
    return this.httpClient.get(this.bankListForSanefUrl);
  }

  postForgetPassword(data) {
    let headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    let options = new RequestOptions({ headers: headers });
    let body = `agentId=${data}`;
    return this.http.post(this.forgotPasswordUrl, body, options);
  }

  postChangePassword(old_pass, new_pass) {
    let headers = new Headers();

    headers.append("Content-Type", "application/x-www-form-urlencoded");

    this.createAuthHeader(headers);

    // let options = new RequestOptions({ headers: headers });

    let body = `old_pass=${old_pass}&new_pass=${new_pass}`;

    return this.http.post(this.changePasswordUrl, body, { headers });
  }

  postChangePin(old_pin, new_pin) {
    let headers = new Headers();

    headers.append("Content-Type", "application/x-www-form-urlencoded");

    this.createAuthHeader(headers);

    let body = `oldpin=${old_pin}&newpin=${new_pin}`;

    return this.http.post(this.changePinUrl, body, { headers });
  }

  postMoveIncome() {
    let headers = new Headers();

    this.createAuthHeader(headers);

    headers.append("Content-Type", "application/json");

    return this.http.post(this.moveIncomeUrl, {}, { headers });
  }

  postValidateMerchant(data) {
    let headers = new Headers();

    this.createAuthHeader(headers);

    headers.append("Content-Type", "application/json");

    return this.http.post(this.validateMerchant, data, { headers });
  }

  postExtCashoutValidate(data) {
    let headers = new Headers();

    this.createAuthHeader(headers);

    headers.append("Content-Type", "application/json");

    return this.http.post(this.extCashoutValidatoinUrl, data, { headers });
  }

  postMobileTransfer(data) {
    let headers = new Headers();

    this.createAuthHeader(headers);

    headers.append("Content-Type", "application/json");

    return this.http.post(this.mobileTransferUrl, data, { headers });
  }

  postRecharge(data) {
    let headers = new Headers();

    this.createAuthHeader(headers);

    headers.append("Content-Type", "application/json");

    return this.http.post(this.rechargeUrl, data, { headers });
  }

  postPayBills(data) {
    let headers = new Headers();

    this.createAuthHeader(headers);

    headers.append("Content-Type", "application/json");

    return this.http.post(this.payBillsUrl, data, { headers });
  }

  postWithdrawMoney(data) {
    let headers = new Headers();

    this.createAuthHeader(headers);

    headers.append("Content-Type", "application/json");

    return this.http.post(this.withdrawMoney, data, { headers });
  }

  postNameEnquiry(data) {
    return this.http.post(this.nameEnquiry, data);
  }

  postValidateBillPaymnet(data) {
    let headers = new Headers();

    this.createAuthHeader(headers);

    headers.append("Content-Type", "application/json");

    return this.http.post(this.validateBillPayment, data, { headers });
  }

  postValidateVoucher(data) {
    let headers = new Headers();

    this.createAuthHeader(headers);

    headers.append("Content-Type", "application/json");

    return this.http.post(this.validateVoucher, data, { headers });
  }

  postbankTransfer(data) {
    let headers = new Headers();

    this.createAuthHeader(headers);

    headers.append("Content-Type", "application/json");

    return this.http.post(this.bankTransferUrl, data, { headers });
  }

  postPayMerchant(data) {
    let headers = new Headers();

    this.createAuthHeader(headers);

    headers.append("Content-Type", "application/json");

    return this.http.post(this.payMerchantUrl, data, { headers });
  }

  postExtcachout(data) {
    let headers = new Headers();

    this.createAuthHeader(headers);
    headers.append("Content-Type", "application/json");
    return this.http.post(this.extCashoutUrl, data, { headers });
  }

  getBillersMerchants() {
    let headers = new Headers();
    this.createAuthHeader(headers);
    return this.http
      .get(this.billerMarchants, { headers })
      .map(res => res.json());
  }

  getAllBillers() {
    let headers = new Headers();

    this.createAuthHeader(headers);

    return this.http
      .get(this.allBillersUrl, { headers })

      .map(res => res.json());
  }

  getTransactions(after) {
    let headers = new Headers();
    this.createAuthHeader(headers);
    return this.http
      .get(this.baseUrl + "agent/tranlist?after=" + after, { headers })
      .map(res => res.json());
  }

  getTransactionsByMonth(start_date, end_date, after) {
    let headers = new Headers();
    this.createAuthHeader(headers);
    return this.http
      .get(
        this.baseUrl +
          `agent/tranlist?trantype=&after=${after}&start_date=${start_date}&end_date=${end_date}`,
        { headers }
      )
      .map(res => res.json());
  }

  getTransactionsHistoryByMonth(start_date, end_date, after) {
    let headers = new Headers();
    this.createAuthHeader(headers);
    return this.http
      .get(
        `${this.transactionHistoryUrl}&trantype=&after=${after}&start_date=${start_date}&end_date=${end_date}`,
        { headers }
      )
      .map(res => res.json());
  }

  getStatesAndCities() {
    return this.http.get(this.statesUrl).map(res => res.json());
  }

  getAgentProfileInfo() {
    let headers = new Headers();
    this.createAuthHeader(headers);
    return this.http.get(this.agentProfile, { headers }).map(res => res.json());
  }

  postAccountEnquiry(data) {
    return this.http.post(this.accountEnquiryUrl, data);
  }

  postCreateAccount(data) {
    return this.http.post(this.createAccountUrl, data);
  }

  postAgentRegistration(data) {
    return this.http.post(this.registeragent, data);
  }

  postAgentProfile(data) {
    return this.http.post(this.saveAgentProfile, data);
  }

  postAgentBusinessProfile(data) {
    return this.http.post(this.saveBusinessProfileUrl, data);
  }

  postDeleteAgentBusinessProfile(data) {
    return this.http.post(this.deleteBusinessProfileUrl, data);
  }

  // return this.http.get(`http://192.168.1.32:8000/api/agent/profile/${agentCode}`)
  getAgentProfileImg(agentCode) {
    return this.http
      .get(this.laravelBaseUrl + "agent/profile/" + agentCode)
      .map(res => res.json());
  }

  getEvents(status) {
    return this.http.get(this.eventsUrl + status).map(res => res.json());
  }

  fetchAgentAccounts(code, status, page) {
    return this.http
      .get(`${this.fetchMyAccountsUrl}/${code}/${status}?page=${page}`)
      .map(res => res.json());
  }

  searchAgentAccounts(page, code, searchTerm) {
    return this.http
      .get(
        `${this.searchAgentAccountsUrl}?page=${page}&code=${code}&term=${searchTerm}`
      )
      .map(res => res.json());
  }

  getAgentInfo() {
    let headers = new Headers();
    this.createAuthHeader(headers);
    return this.http
      .get(this.agentUrl, { headers })
      .map(res => res.text())
      .catch(this.catchError);
  }

  getMicrofinanceBanks(): Observable<any> {
    return this.httpClient.get(this.microfinanceBanks);
  }

  getMobileMoneyOperators(): Observable<any>{
    return this.httpClient.get(this.mobileMoneyOperators);
  }

  getInsuranceCompanies(): Observable<any> {
    return this.httpClient.get(this.fetchInsuranceCompanies);
  }

  getCardTransactionLogs(after, date): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Authorization",
      window.localStorage.getItem("token")
    );
    return this.httpClient.get(`${this.baseUrl}agent/transact/mpos/list?after=${after}&date=${date}`, { headers });
  }
  //   agent/transact/ussd/list?date=1595548800000&after=0

  getUssdTransactionLogs(after, date): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set(
      "Authorization",
      window.localStorage.getItem("token")
    );
    return this.httpClient.get(`${this.baseUrl}agent/transact/ussd/list?date=${date}&after=${after}`, { headers });
  }

  getUssdCashoutStatus(ref): Observable<any> {

    let headers = new HttpHeaders();
    headers = headers.set(
      "Authorization",
      window.localStorage.getItem("token")
    );
    return this.httpClient.get(`${this.baseUrl}agent/transact/ussd/cashout/check?senderRef=${ref}`, { headers });
    //agent/transact/ussd/cashout/check?senderRef=ABCDEFGH55904850699
  }

  getCashPickUpLocations(): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Authorization",
      window.localStorage.getItem("token")
    );
    return this.httpClient.get(this.cashPickUpUrl, { headers });
  }

  postCashPickUpTransaction(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Authorization",
      window.localStorage.getItem("token")
    );
    return this.httpClient.post(this.cashPickUpTransactionUrl, data, {
      headers
    });
  }

  postMposCashOut(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Authorization",
      window.localStorage.getItem("token")
    );
    return this.httpClient.post(this.mposCashout, data, { headers });
  }

  postUssdTransfer(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Authorization",
      window.localStorage.getItem("token")
    );
    return this.httpClient.post(this.ussdTransferUrl, data, { headers });
  }

  postAkuVerification(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Authorization",
      window.localStorage.getItem("token")
    );
    return this.httpClient.post(this.akuCashoutVerificationUrl, data, {
      headers
    });
  }

  getPendingTransactions(): Observable<any> {
    let headers = new HttpHeaders();
    headers = this.setAuthHeader(headers);
    return this.httpClient.get(this.pendingTransactionList, { headers });
  }

  postResolveTransaction(transactionId) {
    let headers = new HttpHeaders();
    headers = this.setAuthHeader(headers);
    return this.httpClient.post(
      `${this.baseUrl}agent/transact/pending/resolve?tranId=${transactionId}`,
      {},
      { headers }
    );
  }

  postPinpadLinking(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Authorization",
      window.localStorage.getItem("token")
    );
    return this.httpClient.post(this.linkPinPadUrl, data, { headers });
  }

  postCheckLinkedPinPad(data): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Authorization",
      window.localStorage.getItem("token")
    );
    return this.httpClient.post(this.checkLinkedPinPadUrl, data, { headers });
  }

  getAccInfo() {
    let headers = new Headers();
    this.createAuthHeader(headers);
    return this.http
      .get(this.accUrl, { headers })
      .map(res => res.json())
      .catch(this.catchError);
  }

  getBillerProducts() {
    let headers = new Headers();
    this.createAuthHeader(headers);
    return this.http.get(this.billerUrl, { headers }).map(res => res.json());
  }

  getInfo() {
    return this.http
      .get(this.url)
      .do(this.logResponse)
      .map(this.extractData)
      .catch(this.getInfo);
  }

  login(username, password, expires = 1440) {
    let headers = new Headers();
    headers.append("Content-Type", "application/x-www-form-urlencoded");
    let options = new RequestOptions({ headers: headers });
    let body = `userName=${username}&password=${password}&sessionLength=${expires}`;
    return this.http.post(this.url, body, options);
  }

  setAuthHeader(headers: HttpHeaders) {
    return headers.set("Authorization", window.localStorage.getItem("token"));
  }

  createAuthHeader(headers: Headers) {
    headers.append("Authorization", window.localStorage.getItem("token"));
  }

  loggedIn() {
    if (window.localStorage.getItem("token")) return true;
    return false;
  }

  logout() {
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("session");
    window.localStorage.removeItem("agentId");
    window.localStorage.removeItem("agentObj");
    this.app.getRootNav().setRoot(LoginPage);
  }

  private logResponse(res: Response) {
    console.log(res);
  }

  private extractData(res: Response) {
    return res.json();
  }

  private catchError(error: Response | any) {
    return Observable.throw(error.json() || "server error");
  }
}



// WEBPACK FOOTER //
// ./src/providers/request-service/request-service.ts